
import { defineComponent, onMounted, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import List from '@/common/components/UI/List/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'

// module components
import StoriesListItem from '@/modules/StoriesModule/components/StoriesListItem/index.vue'
import StoryForm from '@/modules/StoriesModule/components/StoryForm/index.vue'

// realisations
import { stories } from '@/core/realisations/stories.realisation'

// types
import { StoryT } from '@/core/types/stories.types'

// classes
import { DataState } from '@/core/classes/DataState.class'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'the-button': TheButton,
        'failed-fetch': FailedFetch,
        list: List,
        'stories-list-item': StoriesListItem,
        'story-form': StoryForm,
    },
    setup() {
        const state = reactive(new DataState<StoryT>({}))

        const form_state = reactive({
            story: null as StoryT | null,
            is_opened: false,
            is_create: false,
            is_update: false,
        })

        const loadStories = async (page: number) => {
            state.pagination.current_page = page

            try {
                state.is_loading = true
                const data = await stories.getList(page)

                state.list = data.data
                state.pagination.total_pages = data.meta.last_page

                state.is_failed = false
                state.failure.error_state.is_cancel = false
            } catch (error) {
                state.failure.catchError(error)

                if (!state.failure.error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!state.failure.error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        onMounted(() => loadStories(1))

        const startCreate = () => {
            form_state.is_update = false
            form_state.is_create = true
            form_state.is_opened = true
        }

        const startUpdate = (story: StoryT) => {
            form_state.story = story
            form_state.is_create = false
            form_state.is_update = true
            form_state.is_opened = true
        }

        const closeForm = () => {
            form_state.is_opened = false
            form_state.is_create = false
            form_state.is_update = false
            form_state.story = null
        }

        const onFormSave = () => {
            loadStories(state.pagination.current_page)
        }

        const onStoryPublished = (story_index: number) => {
            state.list[story_index].published = true
        }

        const onStoryUnpublished = (story_index: number) => {
            state.list[story_index].published = false
        }

        const onStoryDeleted = (story_index: number) => {
            state.list.splice(story_index, 1)
        }

        return {
            state,
            form_state,
            loadStories,
            startCreate,
            startUpdate,
            closeForm,
            onFormSave,
            onStoryPublished,
            onStoryUnpublished,
            onStoryDeleted,
        }
    },
})
